function Belize({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_645)">
        <path d="M32 16C32 10.5087 29.2332 5.6641 25.0179 2.7826L16 2.08691L6.98206 2.78254C2.76687 5.6641 0 10.5087 0 16C0 21.4914 2.76687 26.3359 6.98206 29.2174L16 29.913L25.0179 29.2174C29.2332 26.3359 32 21.4914 32 16Z" fill="#0052B4"/>
        <path d="M25.0179 2.78262C22.4501 1.02725 19.3452 0 16 0C12.6548 0 9.54987 1.02725 6.98206 2.78262H25.0179Z" fill="#A2001D"/>
        <path d="M6.98206 29.2173C9.5498 30.9727 12.6548 31.9999 16 31.9999C19.3452 31.9999 22.4501 30.9727 25.0179 29.2173H6.98206Z" fill="#A2001D"/>
        <path d="M16 23.652C20.2262 23.652 23.6522 20.226 23.6522 15.9998C23.6522 11.7737 20.2262 8.34766 16 8.34766C11.7738 8.34766 8.34778 11.7737 8.34778 15.9998C8.34778 20.226 11.7738 23.652 16 23.652Z" fill="#F0F0F0"/>
        <path d="M16 22.261C19.4578 22.261 22.2609 19.4579 22.2609 16.0001C22.2609 12.5423 19.4578 9.73926 16 9.73926C12.5422 9.73926 9.73914 12.5423 9.73914 16.0001C9.73914 19.4579 12.5422 22.261 16 22.261Z" fill="#6DA544"/>
        <path d="M16 20.174C18.3052 20.174 20.1739 18.3053 20.1739 16.0001C20.1739 13.6949 18.3052 11.8262 16 11.8262C13.6948 11.8262 11.826 13.6949 11.826 16.0001C11.826 18.3053 13.6948 20.174 16 20.174Z" fill="#F0F0F0"/>
        <path d="M16 14.9565L13.7391 16V17.7392L16 19.1305L18.2609 17.7392V16L16 14.9565Z" fill="#0052B4"/>
        <path d="M13.7391 13.9131H18.2609V16H13.7391V13.9131Z" fill="#FFDA44"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Belize;
